"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setQuantity = exports.getViews = exports.disableThreeDViewer = exports.enableThreeDViewer = exports.addToCart = exports.changeOption = exports.watchPrice = exports.goBack = exports.currencySelector = exports.productShutterstockAuthorSelector = exports.productBannedSelector = exports.productDisabledSelector = exports.productReadySelector = exports.show3dSelector = exports.siblingProductsSelector = exports.singularSelector = exports.clonesSelector = exports.tagsSelector = exports.authorSelector = exports.stockSelector = exports.stockMapSelector = exports.optionsSelector = exports.conditionSelector = exports.productLoadingSelector = exports.editPathSelector = exports.viewsSelector = exports.productSelector = exports.GET_VIEWS_POLL = exports.GET_VIEWS_FAIL = exports.GET_VIEWS_SUCCESS = exports.GET_VIEWS_START = exports.GET_THREE_D_VIEWER_FAIL = exports.GET_THREE_D_VIEWER_SUCCESS = exports.GET_THREE_D_VIEWER_START = exports.ADD_TO_CART_FAIL = exports.ADD_TO_CART_SUCCESS = exports.ADD_TO_CART_START = exports.CHANGE_QUANTITY_FAIL = exports.CHANGE_QUANTITY_SUCCESS = exports.CHANGE_QUANTITY_START = exports.CHANGE_OPTION_FAIL = exports.CHANGE_OPTION_SUCCESS = exports.CHANGE_OPTION_START = exports.moduleName = void 0;
var constants_1 = require("../../../constants");
var config_1 = require("../config");
var reselect_1 = require("reselect");
var three_d_settings_1 = __importDefault(require("../../../utils/threejs/three-d-settings"));
var delay_1 = __importDefault(require("../../../utils/delay"));
var track_event_1 = __importDefault(require("../../../utils/track-event"));
var axios_1 = __importDefault(require("axios"));
var store_1 = __importStar(require("../../HeaderApp/store"));
var cart_info_1 = require("./cart-info");
exports.moduleName = 'product';
var prefix = "".concat(config_1.appName, "/").concat(exports.moduleName);
exports.CHANGE_OPTION_START = "".concat(prefix, "/CHANGE_OPTION_START");
exports.CHANGE_OPTION_SUCCESS = "".concat(prefix, "/CHANGE_OPTION_SUCCESS");
exports.CHANGE_OPTION_FAIL = "".concat(prefix, "/CHANGE_OPTION_FAIL");
exports.CHANGE_QUANTITY_START = "".concat(prefix, "/SET_QUANTITY");
exports.CHANGE_QUANTITY_SUCCESS = "".concat(prefix, "/SET_QUANTITY_SUCCESS");
exports.CHANGE_QUANTITY_FAIL = "".concat(prefix, "/SET_QUANTITY_FAIL");
exports.ADD_TO_CART_START = "".concat(prefix, "/ADD_TO_CART_START");
exports.ADD_TO_CART_SUCCESS = "".concat(prefix, "/ADD_TO_CART_SUCCESS");
exports.ADD_TO_CART_FAIL = "".concat(prefix, "/ADD_TO_CART_FAIL");
exports.GET_THREE_D_VIEWER_START = "".concat(prefix, "/GET_THREE_D_VIEWER_START");
exports.GET_THREE_D_VIEWER_SUCCESS = "".concat(prefix, "/GET_THREE_D_VIEWER_SUCCESS");
exports.GET_THREE_D_VIEWER_FAIL = "".concat(prefix, "/GET_THREE_D_VIEWER_FAIL");
exports.GET_VIEWS_START = "".concat(prefix, "/GET_VIEWS_START");
exports.GET_VIEWS_SUCCESS = "".concat(prefix, "/GET_VIEWS_SUCCESS");
exports.GET_VIEWS_FAIL = "".concat(prefix, "/GET_VIEWS_FAIL");
exports.GET_VIEWS_POLL = "".concat(prefix, "/GET_VIEWS_POLL");
var defaultProduct = {
    id: 0,
    condition: {
        options: {},
        quantity: 0,
        title: '',
        category: '',
        price: {
            basePrice: 0,
            currentPrice: 0
        }
    },
    badges: {
        discount: 0,
        quality: false,
        delivery: false,
        popularity: 0,
        certified: false,
        novelty: false
    },
    options: [],
    author: {
        name: '',
        storePath: '',
        inventoryPath: ''
    },
    stock: [],
    views: {
        alt: '',
        title: ''
    },
    neighboring: { next: {}, previous: {} },
    sellableId: 0,
    sellableType: '',
    singular: '',
    banned: false,
    editPath: ''
};
function reducer(state, action) {
    var _a, _b;
    if (state === void 0) { state = defaultProduct; }
    var type = action.type, payload = action.payload, error = action.error, response = action.response;
    switch (type) {
        case constants_1.ITEM + constants_1.LOAD_DATA + constants_1.START:
            return defaultProduct;
        case constants_1.ITEM + constants_1.LOAD_DATA + constants_1.SUCCESS:
            return response.product;
        case exports.CHANGE_OPTION_START:
            return __assign(__assign({}, state), { condition: __assign(__assign({}, state.condition), { options: __assign(__assign({}, state.condition.options), (_a = {}, _a[payload.name] = payload.value, _a)) }), loading: true });
        case exports.CHANGE_OPTION_SUCCESS:
            return __assign(__assign({}, state), { condition: __assign(__assign({}, state.condition), { price: payload.price, options: __assign(__assign({}, state.condition.options), (_b = {}, _b[payload.name] = payload.value, _b)) }), views: __assign(__assign({}, state.views), { large: payload.views[1], small: payload.views[2] }), circulations: payload.circulations, loading: false });
        case exports.GET_VIEWS_FAIL:
        case exports.CHANGE_OPTION_FAIL:
        case exports.ADD_TO_CART_FAIL:
        case exports.CHANGE_QUANTITY_FAIL:
            return __assign(__assign({}, state), { error: error, loading: false });
        case exports.GET_THREE_D_VIEWER_START:
        case exports.ADD_TO_CART_START:
            return __assign(__assign({}, state), { loading: true });
        case exports.CHANGE_QUANTITY_START:
            return __assign(__assign({}, state), { condition: __assign(__assign({}, state.condition), { quantity: payload }), loading: true });
        case exports.GET_THREE_D_VIEWER_SUCCESS:
        case exports.ADD_TO_CART_SUCCESS:
            return __assign(__assign({}, state), { loading: false });
        case exports.GET_VIEWS_SUCCESS:
            return __assign(__assign({}, state), { views: __assign(__assign({}, state.views), { large: payload.views[1], small: payload.views[2] }), ready: true });
        case exports.CHANGE_QUANTITY_SUCCESS:
            return __assign(__assign({}, state), { condition: __assign(__assign({}, state.condition), { price: payload }), loading: false });
        default:
            return state;
    }
}
exports.default = reducer;
/**
 * Selectors
 * */
var productSelector = function (state) { return (__assign(__assign({}, state[exports.moduleName]), { condition: __assign(__assign({}, state[exports.moduleName].condition), { disabled: isProductDisabled(state) }), options: getCurrentAvaibleOptions(state) })); };
exports.productSelector = productSelector;
var viewsSelector = function (state) { return state[exports.moduleName].views; };
exports.viewsSelector = viewsSelector;
var editPathSelector = function (state) { return state[exports.moduleName].editPath; };
exports.editPathSelector = editPathSelector;
var productLoadingSelector = function (state) { return state[exports.moduleName].loading; };
exports.productLoadingSelector = productLoadingSelector;
var conditionSelector = function (state) { return state[exports.moduleName].condition; };
exports.conditionSelector = conditionSelector;
var optionsSelector = function (state) { return state[exports.moduleName].options; };
exports.optionsSelector = optionsSelector;
var stockMapSelector = function (state) { return state[exports.moduleName].stock; };
exports.stockMapSelector = stockMapSelector;
exports.stockSelector = (0, reselect_1.createSelector)(exports.stockMapSelector, function (stock) {
    return Array.isArray(stock) ? stock.map(function (item) { return (__assign({}, item[0])); }) : stock;
});
var authorSelector = function (state) { return state[exports.moduleName].author; };
exports.authorSelector = authorSelector;
var tagsSelector = function (state) { return state[exports.moduleName].tags; };
exports.tagsSelector = tagsSelector;
var clonesSelector = function (state) { return state[exports.moduleName].clones; };
exports.clonesSelector = clonesSelector;
var singularSelector = function (state) { return state[exports.moduleName].singular; };
exports.singularSelector = singularSelector;
var siblingProductsSelector = function (state) {
    return state[exports.moduleName].siblingProducts;
};
exports.siblingProductsSelector = siblingProductsSelector;
var show3dSelector = function (state) { return state[exports.moduleName].show3d; };
exports.show3dSelector = show3dSelector;
var productReadySelector = function (state) { return state[exports.moduleName].ready; };
exports.productReadySelector = productReadySelector;
var productDisabledSelector = function (state) { return state[exports.moduleName].disabled; };
exports.productDisabledSelector = productDisabledSelector;
var productBannedSelector = function (state) { return state[exports.moduleName].banned; };
exports.productBannedSelector = productBannedSelector;
var productShutterstockAuthorSelector = function (state) {
    return state[exports.moduleName].shutterStockAuthor;
};
exports.productShutterstockAuthorSelector = productShutterstockAuthorSelector;
var currencySelector = function (state) { return state.currency; };
exports.currencySelector = currencySelector;
var isOptionDisabled = function (_a, currentOptions, stock) {
    var name = _a.name, value = _a.value;
    var matches = stock
        .filter(function (item) { return item[name] === value; }) // get all matches
        .reduce(function (acc, item) {
        var cloneItem = __assign({}, item);
        delete cloneItem[name];
        return __spreadArray(__spreadArray([], acc, true), [__assign({}, cloneItem)], false);
    }, []); // remove the name field from matches
    return matches.some(function (match) {
        return Object.keys(match).every(function (key) { return currentOptions[key] === match[key]; });
    });
};
var isProductDisabled = function (state) {
    var currentOptions = (0, exports.conditionSelector)(state).options;
    var productDisabled = (0, exports.productDisabledSelector)(state);
    var productBanned = (0, exports.productBannedSelector)(state);
    var stock = (0, exports.stockSelector)(state);
    return (productBanned ||
        productDisabled ||
        (Array.isArray(stock)
            ? stock.some(function (match) {
                return Object.keys(match).every(function (key) { return currentOptions[key] === match[key]; });
            })
            : stock < 0));
};
var getCurrentAvaibleOptions = function (state) {
    var options = (0, exports.optionsSelector)(state);
    var currentOptions = (0, exports.conditionSelector)(state).options;
    var stock = (0, exports.stockSelector)(state);
    return Array.isArray(options) ? options.map(function (_a) {
        var name = _a.name, content = _a.content;
        return {
            name: name,
            content: content.map(function (item) {
                return __assign(__assign({}, item), { disabled: isOptionDisabled({ name: name, value: item.value }, currentOptions, stock) });
            }),
        };
    }) : [];
};
/**
 * Action Creators
 * */
var goBack = function () { return function () {
    if (window.history.length > 1) {
        window.history.back();
    }
    else {
        window.location.assign('/');
    }
}; };
exports.goBack = goBack;
var watchPrice = function () { return function () {
    var _a;
    (0, track_event_1.default)({
        category: 'closeup',
        action: 'click',
        label: 'price_control',
    });
    (_a = window.subscribePopup) === null || _a === void 0 ? void 0 : _a.show();
}; };
exports.watchPrice = watchPrice;
var convertOptionsToString = function (options) {
    return options
        ? Object.keys(options)
            .map(function (key) { return "".concat(key, ":").concat(options[key]); })
            .join('|')
        : '';
};
var cacheOfViews = {};
var cacheOfPrice = {};
var isProductReady = function (array) { return array.every(function (i) { return !!i; }); };
var fetchingCount = 0;
var fetchViews = function (id, options) {
    fetchingCount = fetchingCount + 1;
    var stringOptions = convertOptionsToString(options);
    if (fetchingCount > 20) {
        return [[], [], []];
    }
    if (cacheOfViews[stringOptions]) {
        return cacheOfViews[stringOptions];
    }
    return fetch("./".concat(id, ".json").concat(stringOptions ? "?present[variant]=".concat(stringOptions) : ''), {
        headers: {
            Accept: 'application/json',
        },
        credentials: 'same-origin',
    })
        .then(function (res) {
        return res.json();
    })
        .then(function (json) {
        if (Object.keys(json).length && isProductReady(json)) {
            cacheOfViews[stringOptions] = json;
            return json;
        }
        else {
            return (0, delay_1.default)(2000).then(function () { return fetchViews(id, options); });
        }
    })
        .catch(function () {
        return (0, delay_1.default)(2000).then(function () { return fetchViews(id, options); });
    });
};
var getViewsByOptions = function (id, options) { return __awaiter(void 0, void 0, void 0, function () {
    var err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                return [4 /*yield*/, fetchViews(id, options)];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_1 = _a.sent();
                throw err_1;
            case 3: return [2 /*return*/];
        }
    });
}); };
var getPriceByOptions = function (id, quantity, options) { return __awaiter(void 0, void 0, void 0, function () {
    var stringifiedOptions, cacheID_1, err_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                stringifiedOptions = convertOptionsToString(options);
                cacheID_1 = "".concat(quantity, "/").concat(stringifiedOptions);
                if (cacheOfPrice[cacheID_1]) {
                    return [2 /*return*/, cacheOfPrice[cacheID_1]];
                }
                return [4 /*yield*/, fetch("./".concat(id, "/current_price.json?quantity=").concat(quantity, "&variant=").concat(stringifiedOptions), {
                        headers: {
                            Accept: 'application/json',
                        },
                        credentials: 'same-origin',
                    }).then(function (res) {
                        var result = res.json();
                        cacheOfPrice[cacheID_1] = result;
                        return result;
                    })];
            case 1: return [2 /*return*/, _a.sent()];
            case 2:
                err_2 = _a.sent();
                throw err_2;
            case 3: return [2 /*return*/];
        }
    });
}); };
var changeOption = function (name, value) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, sellableId, _b, quantity, options, views, _c, basePrice, currentPrice, circulations, error_1;
    var _d, _e;
    return __generator(this, function (_f) {
        switch (_f.label) {
            case 0:
                if (!value) return [3 /*break*/, 5];
                _f.label = 1;
            case 1:
                _f.trys.push([1, 4, , 5]);
                dispatch({
                    type: exports.CHANGE_OPTION_START,
                    payload: {
                        name: name,
                        value: value,
                    },
                });
                _a = getState().product, sellableId = _a.sellableId, _b = _a.condition, quantity = _b.quantity, options = _b.options;
                return [4 /*yield*/, getViewsByOptions(sellableId, __assign(__assign({}, options), (_d = {}, _d[name] = value, _d)))];
            case 2:
                views = _f.sent();
                return [4 /*yield*/, getPriceByOptions(sellableId, quantity, __assign(__assign({}, options), (_e = {}, _e[name] = value, _e)))];
            case 3:
                _c = _f.sent(), basePrice = _c.base_price, currentPrice = _c.current_price, circulations = _c.circulations;
                dispatch({
                    type: exports.CHANGE_OPTION_SUCCESS,
                    payload: {
                        name: name,
                        value: value,
                        views: views,
                        price: {
                            basePrice: basePrice,
                            currentPrice: currentPrice,
                        },
                        circulations: Array.isArray(circulations)
                            ? circulations.map(function (_a) {
                                var minQuantity = _a.min_quantity, pricePerItem = _a.price_per_item;
                                return ({
                                    minQuantity: minQuantity,
                                    pricePerItem: pricePerItem,
                                });
                            })
                            : null,
                    },
                });
                return [3 /*break*/, 5];
            case 4:
                error_1 = _f.sent();
                dispatch({
                    type: exports.CHANGE_OPTION_FAIL,
                    error: error_1,
                });
                return [3 /*break*/, 5];
            case 5: return [2 /*return*/];
        }
    });
}); }; };
exports.changeOption = changeOption;
var addToCart = function () { return function (dispatch, getState) {
    dispatch({
        type: exports.ADD_TO_CART_START,
    });
    var _a = getState(), authenticityToken = _a.authenticityToken, _b = _a.product, id = _b.id, _c = _b.condition, title = _c.title, category = _c.category, options = _c.options, quantity = _c.quantity, currentPrice = _c.price.currentPrice, sellableId = _b.sellableId, sellableType = _b.sellableType;
    var formData = new FormData();
    formData.append('authenticity_token', authenticityToken);
    formData.append('line_item[sellable_id]', sellableId.toString());
    formData.append('line_item[sellable_type]', sellableType);
    formData.append('line_item[quantity]', quantity.toString());
    formData.append('line_item[variant]', options ? convertOptionsToString(options) : '');
    window.flocktory = window.flocktory || [];
    window.flocktory.push([
        'addToCart',
        {
            item: {
                id: id,
                price: currentPrice,
                count: 1,
                title: title,
                categoryId: category,
            },
        },
    ]);
    (0, track_event_1.default)({
        category: 'closeup',
        action: 'order',
        label: 'busket',
    });
    axios_1.default.post('/line_items', formData)
        .then(function (response) {
        if (response.status === 200) {
            dispatch({
                type: exports.ADD_TO_CART_SUCCESS,
            });
            dispatch((0, cart_info_1.setCartInfoAction)(response.data.cartInfo));
            store_1.default.dispatch((0, store_1.setCartItemsAction)(response.data.cartItems));
        }
        else {
            throw new Error('Error of response');
        }
    })
        .catch(function (error) {
        dispatch({ type: exports.ADD_TO_CART_FAIL, error: error });
    });
}; };
exports.addToCart = addToCart;
var enableThreeDViewer = function (element) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, singular, arts, condition, ThreeJSMediator;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getState().product, singular = _a.singular, arts = _a.arts, condition = _a.condition;
                dispatch({
                    type: exports.GET_THREE_D_VIEWER_START,
                });
                return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('../../../utils/threejs/ThreeJSMediator')); })];
            case 1:
                ThreeJSMediator = (_b.sent()).default;
                ThreeJSMediator.enable(element);
                (function () { return __awaiter(void 0, void 0, void 0, function () {
                    var err_3;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (!(three_d_settings_1.default && three_d_settings_1.default[singular])) return [3 /*break*/, 4];
                                _a.label = 1;
                            case 1:
                                _a.trys.push([1, 3, , 4]);
                                return [4 /*yield*/, ThreeJSMediator.applySettings(__assign(__assign({}, three_d_settings_1.default[singular]), { condition: {
                                            variants: condition.options,
                                        }, arts: arts }))];
                            case 2:
                                _a.sent();
                                dispatch({
                                    type: exports.GET_THREE_D_VIEWER_SUCCESS,
                                });
                                return [3 /*break*/, 4];
                            case 3:
                                err_3 = _a.sent();
                                dispatch({
                                    type: exports.GET_THREE_D_VIEWER_FAIL,
                                });
                                throw err_3;
                            case 4: return [2 /*return*/];
                        }
                    });
                }); })();
                return [2 /*return*/];
        }
    });
}); }; };
exports.enableThreeDViewer = enableThreeDViewer;
var disableThreeDViewer = function () { return function () { return __awaiter(void 0, void 0, void 0, function () {
    var ThreeJSMediator;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require('../../../utils/threejs/ThreeJSMediator')); })];
            case 1:
                ThreeJSMediator = (_a.sent()).default;
                ThreeJSMediator.disable();
                return [2 /*return*/];
        }
    });
}); }; };
exports.disableThreeDViewer = disableThreeDViewer;
var getViews = function () { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, sellableId, options, views, error_2;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                _a = getState().product, sellableId = _a.sellableId, options = _a.condition.options;
                dispatch({
                    type: exports.GET_VIEWS_START,
                });
                _b.label = 1;
            case 1:
                _b.trys.push([1, 3, , 4]);
                dispatch({
                    type: exports.GET_VIEWS_POLL,
                });
                return [4 /*yield*/, getViewsByOptions(sellableId, options)];
            case 2:
                views = _b.sent();
                dispatch({
                    type: exports.GET_VIEWS_SUCCESS,
                    payload: {
                        views: views,
                    },
                });
                return [3 /*break*/, 4];
            case 3:
                error_2 = _b.sent();
                dispatch({
                    type: exports.GET_VIEWS_FAIL,
                    error: error_2,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports.getViews = getViews;
var setQuantity = function (quantity) { return function (dispatch, getState) { return __awaiter(void 0, void 0, void 0, function () {
    var _a, sellableId, options, _b, basePrice, currentPrice, error_3;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0:
                dispatch({ type: exports.CHANGE_QUANTITY_START, payload: quantity });
                _a = getState().product, sellableId = _a.sellableId, options = _a.condition.options;
                _c.label = 1;
            case 1:
                _c.trys.push([1, 3, , 4]);
                return [4 /*yield*/, getPriceByOptions(sellableId, quantity, options)];
            case 2:
                _b = _c.sent(), basePrice = _b.base_price, currentPrice = _b.current_price;
                dispatch({
                    type: exports.CHANGE_QUANTITY_SUCCESS,
                    payload: { basePrice: basePrice, currentPrice: currentPrice },
                });
                return [3 /*break*/, 4];
            case 3:
                error_3 = _c.sent();
                dispatch({ type: exports.CHANGE_QUANTITY_FAIL, error: error_3 });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
exports.setQuantity = setQuantity;
